import React, { useState, useEffect } from 'react';
//import { Container, Row, Col } from 'react-bootstrap';
import Lang from 'libraries/Lang';
import { getTopTrendsData } from 'libraries/trendsData';
import DestinationSectionLoader from './destinationSectionLoader';

const TopAirDestinations = (prop) => {
    const [topAirDestinations, setTopAirDestinations] = useState(false);
    const [isDataAvailable, setIsDataAvailable] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const getTopAirDestinationsPromise = getTopTrendsData('/api/trends/topSearchedAirDestinations', prop.env, prop.start, prop.end);

        getTopAirDestinationsPromise.then((result) => {
            setIsLoading(false);
            if(result !== undefined && result !== null && result.length > 0) {
                setIsDataAvailable(true);
                setTopAirDestinations(result);
            }
        });
    }, []);

    const showDepToDest = (depToDests) => {
        if (Object.keys(depToDests).length > 0) {
            const deptureDate = new Date(depToDests.depDate).toUTCString().slice(0, 11);

            return (
                <>
                    <div className="font-weight-bold">
                        <img 
                            src={`https://travel-img-assets.s3-us-west-2.amazonaws.com/flights/carrier-48x48/${(depToDests.carrierCode).toLowerCase()}.png`}
                            alt={depToDests.carrier}
                            className="initial loading mb-2 flight-airline-logo-mobile mr-2 flex-shrink-0"
                            onError={(e) => {
                                e.target.style.visibility = "hidden";
                            }}
                        />
                        <span>{depToDests.carrier}</span>
                    </div>
                    <div className="font-weight-600">
                        {deptureDate}
                    </div>
                    <div className="d-flex font-size-md mt-2 font-weight-600">
                        <span>{depToDests.depAirport}</span>
                        <span className="mx-2">
                            <img src="https://redtag-travel-images.s3.us-east-1.amazonaws.com/flight-with-arrow.png" alt="Flight" />
                        </span>
                        <span>{depToDests.destAirport}</span>
                    </div>
                    <div className="mt-1 font-size-sm">
                        {Lang.trans('trends_top_cruises.from')}
                    </div>
                    <div className="d-flex justify-content-between align-items-end mt-1">
                        <div className="font-weight-bold" style={{color: "#1865bf"}}>${depToDests.priceFrom}</div>
                        <span style={{color: "#b22726"}}>{Lang.trans('trends_top_cruises.direct')}</span>
                    </div>
                </>
            );
        }

        return (<></>);
    };

    // https://www.redtag.ca/images/hotels/default.jpg
    const defaultImage = 'https://travel-img-assets.s3.us-west-2.amazonaws.com/no-image/no-image-500x300.png';

    return (
        <>
            { isLoading == false ?   
                <>
                    { isDataAvailable !== false ?
                        <div className="p-5 mx-sm-5">
                            <div className="container mb-3 pb-1">
                                <h4 className="font-weight-bold mb-3">{Lang.trans('trends_top_airdestinations.title')}</h4>
                                <div className="row mb-3 gutter-10  ">
                                    { topAirDestinations !== undefined && topAirDestinations !== null && topAirDestinations.length > 0 ?
                                        <>
                                            {topAirDestinations.map((item, key) => {
                                                if( item.name != undefined && item.hasOwnProperty('depToDests') && Object.keys(item.depToDests).length > 0) {
                                                    return (
                                                        <div className="col-sm-6 col-xl col-lg-4 col-md-4 mb-3 mb-xl-0">
                                                            <div className="rounded-4 box-shadow-md overflow-hidden">
                                                                <button className="btn-unstyled deal-list-card text-decoration-none" style={{cursor: "default"}}>
                                                                    <div className="position-relative w-100">
                                                                        <img className="w-100 object-fit-cover" height="170" src={(item.image != undefined && item.image != '') ? item.image : defaultImage} data-was-processed="true" />
                                                                        <div className="position-absolute left-bottom py-2 px-3 rounded-5 bg-warning">
                                                                            <h6 className="text-black font-weight-600 text-center mb-0 font-size-md">
                                                                                {item.name.split('(')[0]}
                                                                            </h6>
                                                                        </div>
                                                                    </div>
                                                                    <div className="content p-3 text-left w-100">
                                                                        {showDepToDest(item.depToDests)}
                                                                    </div>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    );
                                                }  
                                            })}
                                        </>
                                    :
                                        <DestinationSectionLoader />
                                    }
                                </div>
                            </div>
                        </div>
                    : null }
                </>
            : <DestinationSectionLoader />}
        </>
    );
};

export default TopAirDestinations;
